import { config } from './config';

export function getSignalingUrl(peerId, roomId, token) {
    const hostname = config.serverHostname || window.location.hostname;

    const url = `wss://${hostname}?peerId=${peerId}&roomId=${roomId}&token=${token}`;

    return url;
}
